export default `



               [╔, , , , , , , ,╔,╔,╔,╔,╔,╔,╔,╔][═,═, , , , , , , ,═,═,═,═,═,═,═][╗,╗,╗, , , , , , , ,╗,╗,╗,╗,╗,╗]
               [║,║,║,║,║,║,║,║, , , , , , , ,║][ , , , , , , , , , , , , , , , ][║,║,║,║, , , , , , , ,║,║,║,║,║]
               [╚,╚,╚,╚,╚,╚,╚, , , , , , , ,╚,╚][═,═,═,═,═,═, , , , , , , ,═,═,═][╝,╝,╝,╝,╝, , , , , , , ,╝,╝,╝,╝]


             Booting[ ,.,.,.][ , ,.,.][ , , ,.]
`